import { IFilesManagerState, FeatureName as FilesManagerFeatureName } from '@aston/files-manager';
import { IUserPrefsState, FeatureName as UserPreferencesFeatureName } from '@aston/user-prefs';

import { IAppState } from './app-store/state';
import { IDunningActionDetailState } from './dunning-action-detail-store/state';
import { initialState as appInitialState } from './app-store/state';


export interface RootState {
	app: IAppState;
	dunningActionDetail: IDunningActionDetailState;
	[UserPreferencesFeatureName]: IUserPrefsState;
	[FilesManagerFeatureName]: IFilesManagerState,
}

export function getStateFromPreviousSession(state: RootState): Partial<RootState> {
	return {
		app: {
			...appInitialState,

			// only put here anonymous store data that
			// should be kept between sessions
			config: state.app.config,
			factorConfig: state.app.factorConfig,
		},
	};
}
